/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * Deep link component for console pages.
 *
 * @file DeepLink.jsx
 * @author Mohamed yasar arabath M
 */
import { PureComponent } from 'react';
import { shapes } from '@greenville/framework';
import CommonUtils from '../../common/utils/CommonUtils';

import { IS_CONSOLE } from '../../common/constants';

export default class DeepLink extends PureComponent {
  static propTypes = {
    match: shapes.match.isRequired
  };

  componentDidMount() {
    const { courseId } = this.props?.match?.params;

    let consoleContextEncoded = '';
    if (courseId) {
      consoleContextEncoded = CommonUtils.getBase64Encoded(`courses/${courseId}`) || '';
    }

    window.location.href = consoleContextEncoded
      ? `/home2/${consoleContextEncoded}?${IS_CONSOLE}=Y`
      : `/home2?${IS_CONSOLE}=Y`;
  }

  render() {
    return null;
  }
}
